import { ArticlePreview } from '../Article'
import { Cell, FlexContainer, GridContainer } from '~/components/Grid'
import { MobileCategories } from '../Categories'
import { TypeArticleSkeleton, TypeCategorySorting } from '~/types/contentful'
import { Entry } from 'contentful'

export type PostsPreviewGroupProps = {
  posts: Entry<TypeArticleSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>[]
  categories?: TypeCategorySorting<'WITHOUT_UNRESOLVABLE_LINKS', string>
  isAuthorPosts?: boolean
}

export const PostsPreviewGroup = ({ posts, categories, isAuthorPosts }: PostsPreviewGroupProps) => {
  const categoriesInfo = categories?.fields?.categories
  return (
    <div className="relative rounded-[40px] -my-10 mx-0 py-25 px-10 bg-white z-1 max-xl:rounded-[32px] max-xl:-my-8 max-xl:mx-0 max-xl:py-14 max-xl:first:pt-6 max-md:px-0 max-md:py-13 max-md:first:pt-13 last:mb-0">
      <FlexContainer justify="end">
        <GridContainer className="max-xl:w-full max-xl:my-0 max-xl:mx-auto max-xl:py-0 max-xl:px-8 max-xl:max-w-[1000px] max-md:px-4">
          {categoriesInfo && (
            <Cell className="!hidden max-xl:!block max-xl:mb-4 max-md:-mt-8 max-md:mb-2 max-lg:!col-span-8">
              <MobileCategories categories={categoriesInfo} />
            </Cell>
          )}
          {isAuthorPosts && (
            <Cell>
              <h2 className="text-m">Author&apos;s Post</h2>
            </Cell>
          )}
          {posts.map((post) => (
            <Cell key={post.fields.slug?.toString()} className="col-span-6 max-lg:col-span-4">
              <ArticlePreview data={post} />
            </Cell>
          ))}
        </GridContainer>
      </FlexContainer>
    </div>
  )
}
